"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generalDiagnostics = void 0;
exports.generalDiagnostics = {
    INVALID_FUNCTIONAL_SELECTOR(selector, type) {
        return `"${selector}" ${type} is not functional`;
    },
    FORBIDDEN_DEF_IN_COMPLEX_SELECTOR(name) {
        return `cannot define "${name}" inside a complex selector`;
    },
};
//# sourceMappingURL=diagnostics.js.map